App.namespace.wrap('components.re_captcha', (sitekey) => {
  let loaded = false;

  let challengeCallback = null;

  const onSubmit = (token) => {
    if (challengeCallback) {
      challengeCallback(token);
    }
  };

  const show = () => {
    if (!window.grecaptcha) {
      throw new Error('grecaptcha is not loaded');
    }
    window.grecaptcha.reset();
    window.grecaptcha.execute();
  };

  const loadAndShow = (node) => {
    window.captchaOnLoadCallback = () => {
      window.grecaptcha.render(node, {
        sitekey,
        callback: onSubmit,
        size: 'invisible',
      });
      loaded = true;
      show();
    };
    $.getScript('https://www.google.com/recaptcha/api.js?onload=captchaOnLoadCallback&render=explicit');
  };

  const challenge = (node, callback) => {
    challengeCallback = callback;

    if (!loaded) {
      loadAndShow(node);
      return;
    }

    show(node);
  };

  return {
    challenge,
  };
});

